import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { store } from 'app/store';
import { initAnalytics } from 'app/analytics';
import { history } from './history';
import App from './App';
import 'assets/styles/main.scss';

// The former body of main.tsx, unchanged. It is imported DYNAMICALLY by
// main.tsx after the boot gate settles window.__KSDM_CONFIG__, because modules
// in this graph (app/store → authSlice) read getKsdmConfig() at module-eval
// time — a static import would evaluate them before the gate runs.

const rootEl = document.getElementById('react-root');
if (!rootEl) throw new Error('#react-root not found');

// No-op unless __KSDM_CONFIG__.posthog is set; never blocks the render.
initAnalytics();

ReactDOM.createRoot(rootEl).render(
  <Provider store={store}>
    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
    <HistoryRouter history={history as any}>
      <App />
    </HistoryRouter>
  </Provider>
);
